/** Preserve existing rel tokens while securing links that open a new tab. */
export function linkOption() {
  document.querySelectorAll('a[target]').forEach((element) => {
    if (element.getAttribute('target') !== '_blank') return;
    element.relList.add('noopener', 'noreferrer');
    element.classList.add('external');
  });
}
